import { render, staticRenderFns } from "./LatestLeaderboard.vue?vue&type=template&id=47a9f08a&scoped=true&"
import script from "./LatestLeaderboard.vue?vue&type=script&lang=js&"
export * from "./LatestLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./LatestLeaderboard.vue?vue&type=style&index=0&id=47a9f08a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9f08a",
  null
  
)

export default component.exports